module.exports = __webpack_public_path__ + "img/img-mainbanner-bg.5f613608.png";